import { ZipCountryMapping } from './zip-country-mapping.interface';

const usDateFormat = 'MM/dd/yyyy';
const nonUSDateFormat = 'dd/MM/yyyy';
const nonUSDsDateFormat = 'DD/MM/YYYY';
export const timeFormat = 'h:mm a';
const usDateTimeFormat = `${usDateFormat}, ${timeFormat}`;
const nonUSDateTimeFormat = `${nonUSDateFormat}, ${timeFormat}`;
const nonUSWeightUnits = 'kg';
const imperialWeightUnit = 'lbs';
const nonUSLengthUnits = 'cm';
const nonUSLengthUnitNames = 'centimeters';
export const dateLocales = {
  US: 'en-US',
  CA: 'en-GB',
  GB: 'en-GB',
  DE: 'en-GB',
  MX: 'en-GB',
  AU: 'en-GB',
  NS: 'en-US'
};

export const dateFormats = {
  US: usDateFormat,
  CA: nonUSDateFormat,
  GB: nonUSDateFormat,
  DE: nonUSDateFormat,
  MX: nonUSDateFormat,
  AU: nonUSDateFormat,
  NS: usDateFormat
};

export const dsDateFormats = {
  US: 'MM/DD/YYYY',
  CA: nonUSDsDateFormat,
  GB: nonUSDsDateFormat,
  DE: nonUSDsDateFormat,
  MX: nonUSDsDateFormat,
  AU: nonUSDsDateFormat,
  NS: 'MM/DD/YYYY'
};

export const dateTimeFormats = {
  US: usDateTimeFormat,
  CA: nonUSDateTimeFormat,
  GB: nonUSDateTimeFormat,
  DE: nonUSDateTimeFormat,
  MX: nonUSDateTimeFormat,
  AU: nonUSDateTimeFormat,
  NS: usDateTimeFormat
};

export const currencies = {
  US: '$ ',
  CA: 'C$ ',
  GB: '£ ',
  DE: '€ ',
  MX: 'MEX$ ',
  AU: '$ ',
  NS: '$ '
};

export const currencyCodeSymbols = {
  USD: '$ ',
  CAD: 'C$ ',
  GBP: '£ ',
  EUR: '€ ',
  MXN: 'MEX$ ',
  AUD: '$ ',
  Default: '$ '
};

export const weightUnits = {
  US: imperialWeightUnit,
  CA: imperialWeightUnit,
  GB: nonUSWeightUnits,
  DE: nonUSWeightUnits,
  MX: nonUSWeightUnits,
  AU: nonUSWeightUnits,
  NS: imperialWeightUnit
};

export const lengthUnits = {
  US: 'in',
  CA: nonUSLengthUnits,
  GB: nonUSLengthUnits,
  DE: nonUSLengthUnits,
  MX: nonUSLengthUnits,
  AU: nonUSLengthUnits,
  NS: 'in',
};

export const lengthUnitNames = {
  US: 'inches',
  CA: nonUSLengthUnitNames,
  GB: nonUSLengthUnitNames,
  DE: nonUSLengthUnitNames,
  MX: nonUSLengthUnitNames,
  AU: nonUSLengthUnitNames,
  NS: 'inches',
};

export const zipCodeCountryMapping: ZipCountryMapping = {
  Default: {
    length: 10,
    validator: '.*'
  },
  'United States': {
    length: 5,
    validator: '^[0-9]{5}$'
  },
  Canada: {
    length: 7,
    validator: '^[a-zA-Z0-9 —–-]*$'
  },
  Australia: {
    length: 4,
    validator: '^[0-9 —–-]{4}$'
  },
  'Norbar Sturtevant': {
    length: 5,
    validator: '^[0-9]{5}$'
  },
};

const us = 'United States';
const canada = 'Canada';
const uk = 'United Kingdom';
const ireland = 'Ireland';
const england = 'England';
const northIreland = 'Northern Ireland';
const scotland = 'Scotland';
const wales = 'Wales';
const germany = 'Germany';
const australia = 'Australia';
const ns = 'Norbar Sturtevant';

// USA and CA use stateId when saved in the database, for CA province uses dropdown
export const stateDropdownCountries = [us, canada, australia, ns];
export const regionDropDownCountries = [uk, ireland];
export const stateDropdownRegions = [england, northIreland, scotland, wales, ireland];
export const countriesWithoutProvinceOrStateInput = [germany, uk];
// Countries in the contact countries dropdown, for which the state/province field is hidden
export const countriesWithHiddenSTateOrProvinceField = ['Belgium', 'Germany', 'Netherlands', 'Luxembourg',
  'Sweden', 'Finland', 'Hungary', 'Ukraine', 'Austria', 'Malta', 'Poland', 'Denmark', 'Norway', 'Switzerland',
  'Slovakia', 'Czech Republic', 'Iceland', 'Lithuania', 'Germany', 'United Kingdom'];

export const countryCodeValues = {
  US: us,
  CA: canada,
  GB: uk,
  DE: germany,
  AU: australia,
  NS: ns,
};

export const countriesWithDoNotEmail = {
  US: true,
  NS: true,
};

export const countriesWithCreditCardFieldDependencies = {
  US: true,
  NS: true,
};

export const hideDoNotEmail = {
  GB: true,
  DE: true
};

export const countriesWithPaymentTermsDependencies = {
  US: true,
  CA: true,
  GB: true,
  NS: true,
};

export const countriesWithProvince = {
  CA: true
};

export const countriesWithoutLocalAndDistrictTax = {
  CA: true
};

export const oemSkuField = {
  DE: false,
  GB: true,
  US: true,
  CA: true,
  AU: true,
  NS: true
};

export const countriesFromEurope = {
  DE: true,
  GB: true
};

// Countries without area or final destination, but with carrier
export const noAreaOrFinalDestination = {
  AU: true,
};

export const countriesWithoutConsignedWarehouse = {
  DE: true
};


// The code below is used for AM Filtering
export const countriesWithStateOrProvinceField = {
  US: true,
  CA: true,
  GB: false,
  DE: false,
  NS: true
};

export const countriesWithPostalCodeField = {
  US: false,
  CA: true,
  GB: true,
  DE: false,
  AU: true,
  NS: false
};

export const countriesWithCountryField = {
  US: false,
  CA: false,
  GB: false,
  DE: true,
  NS: false
};

// Invoices
export const countriesWithTaxSummary = {
  US: true,
  CA: true,
  GB: false,
  DE: false,
  NS: true
};

// Text for quote filtering menu
export const countriesWithNoCurrencyDisplayed = {
  GB: true,
  DE: true,
  CA: true
};

export enum CountryCode {
  US = 'US',
  CA = 'CA',
  UK = 'GB',
  DE = 'DE',
  AU = 'AU',
  NS = 'NS',
}
